import { MainEnvironment } from './models/main-environment';

export const environment: MainEnvironment = {
  isProd: false,
  ultramarineBaseUrl: 'https://core-staging.racapp.com/api/v1',
  umAuthBaseUrl: 'https://auth-staging.racapp.com',
  authnBaseUrl: 'https://auth-staging.racapp.com',
  umVerifyBaseUrl: 'https://reserve-staging.racapp.com',
  protoApiBaseUrl: 'http://localhost:2121',
  portalBaseUrl: 'https://portal-staging.racapp.com',
  storageBaseUrl: 'https://storage-platform-staging.racapp.com',
  tenantStorageBaseUrl: 'https://storage-staging.racapp.com',
  umClientDomain: 'https://manage-staging.racapp.com',
  bookkitBaseUrl: 'https://broker-staging.racapp.com',
  businessBaseUrl: 'https://business-staging.racapp.com',
  calendlyUrl: 'https://calendly.com/racapp/30min',
  productStatus: 'https://uptime.splitsecondconnect.cloud/status/racapp',
  mapboxAccessToken: 'pk.eyJ1IjoibmVjdGFyaW9zZyIsImEiOiJjbXMwbGY1enQwc2s3MnhzNWJ2cGVvd3cyIn0.uOmyOX_exkZxbW49iybynQ',
};
